/* El isologo y "Klavia" en Plus Jakarta Sans 700, tracking apenas negativo. El cuadrado accent queda sólo para `mark` con `icon`. */
.wordmark {
  --_marca: 28px;
  --_fs: var(--fs-xl);
  display: inline-flex;
  align-items: center;
  gap: var(--s-4);
  font-family: var(--font-display);
  font-size: var(--_fs);
  font-weight: var(--fw-bold);
  letter-spacing: var(--ls-wordmark);
  line-height: 1;
  color: var(--text-strong);
  text-decoration: none;
  border-bottom: 0;
}
.wordmark[data-size="sm"] {
  --_marca: 22px;
  --_fs: var(--fs-md);
  gap: var(--s-3);
}
.wordmark[data-size="lg"] {
  --_marca: 36px;
  --_fs: var(--fs-3xl);
  gap: var(--s-5);
}
.marca {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: var(--_marca);
  height: var(--_marca);
  border-radius: var(--r-badge);
  background: var(--surface-brand);
  color: var(--brand-white);
}
.marca[data-elevated] {
  box-shadow: var(--sh-brand-sm);
}
/* El isologo mide lo mismo de alto que el cuadrado y conserva su proporción (1660:1942). */
.isologo {
  flex: 0 0 auto;
  height: var(--_marca);
  width: auto;
}
.wordmark[data-size="lg"] .marca {
  border-radius: var(--r-md);
}
a.wordmark:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
  border-radius: var(--r-xs);
}
@media (hover: hover) {
  a.wordmark:hover {
    color: var(--text-strong);
    border-bottom: 0;
  }
}
